<template>
  <div>
    <div v-if="showTabs">
      <ul class="nav nav-tabs">
        <li v-for="(tab, index) in tabs" :key="index" class="nav-item" :class="{ dropdown: tab.children }">
          <!-- Wyświetla dropdown -->
          <check-permission
            v-if="tab.children"
            joinType="OR"
            :entityId="entityId"
            :entityType="entityType"
            :permissions="getChildrenPermissions(tab)"
          >
            <dropdown :entityType="entityType" :entityId="entityId" :tab="tab" />
          </check-permission>

          <!-- Wyświetla zakładke -->
          <check-permission v-else :entityId="entityId" :entityType="entityType" :permissions="tab.permissions">
            <tab-link class="nav-link" :tab="tab" />
          </check-permission>
        </li>
      </ul>

      <div class="tab-content">
        <router-view />
      </div>
    </div>

    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script>
import { flat } from '@/utils/flat';
import Dropdown from './Dropdown';
import TabLink from './TabLink';

// @vuese
// Zakładki
// @group Components
export default {
  props: {
    // Lista zakładek
    // format: `{title: string, route: object}`
    tabs: {
      type: Array,
      required: true
    },
    // Encja
    entityType: {
      type: String,
      required: false
    },
    // Id encji
    entityId: {
      type: String,
      required: false
    }
  },
  components: {
    Dropdown,
    TabLink
  },
  methods: {
    // @vuese
    // Sprawdza, czy dana zakładka jest aktualnie otwarta
    isActive(tab) {
      return tab && tab.route && this.$route.name === tab.route.name;
    },
    // @vuese
    // Zwraca uprawnienia dzieci
    getChildrenPermissions(tab) {
      return tab.children && tab.children.length
        ? [
            ...new Set(
              flat(
                tab.children
                  .filter(child => !!child.permissions && child.permissions.length)
                  .map(child => child.permissions)
              )
            )
          ]
        : [];
    }
  },
  computed: {
    // Sprawdza, czy zakładki powinny być widoczne
    showTabs() {
      return this.tabs.some(
        tab => this.isActive(tab) || (tab.children && tab.children.some(childrenTab => this.isActive(childrenTab)))
      );
    }
  }
};
</script>
